module.exports = __webpack_public_path__ + "static/img/nbg.e84bc28.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/pages/nbg.jpg
// module id = Dl51
// module chunks = 7